/**
 * Pad incoming number with preceding string
 * i.e. padNumber(2, 3, '0) -> 002
 * @param {number} number - number
 * @param {number} width - desired width
 * @param {string} placeholder - string to pad with
 * @returns {string}
 */
export const padNumber = (
  number: number,
  width = 2,
  placeholder = '0',
): string => (
  String(number)
    .padStart(width, placeholder)
)

// TODO: rename
export const parseCurrencyToNumber = (value: Nullable<string>): Nullable<number> => {
  const CURRENCY_NUMBER_PATTERN = /[^0-9.-]+/g

  if (!value) {
    return null
  }

  const cleanedNumber = value.replace(CURRENCY_NUMBER_PATTERN, '')
  const parsedNumber = parseFloat(cleanedNumber)
  return Number.isNaN(parsedNumber) ? null : parsedNumber
}

/**
 * Generates a random integer within a specified range.
 * If no range is provided, it defaults to [0, 1).
 *
 * @param {number} [a=1] - The lower bound of the range.
 * @param {number} [b=0] - The upper bound of the range.
 * @returns {number} - A random integer within the specified range.
 */
export const randomInt = (a = 1, b = 0): number => {
  const lower = Math.ceil(Math.min(a, b))
  const upper = Math.floor(Math.max(a, b))
  return Math.floor(lower + Math.random() * (upper - lower + 1))
}
